import React, { memo } from 'react';

import { REQUIRED_SYMBOL } from '@constants/symbols';

import { SubLabelStyle, RequiredSymbol } from './InputSubLabel.style';

const InputSubLabel: React.FC<{
  label?: string;
  required?: boolean;
  inputId?: string;
}> = ({ label = '', required = false, inputId = '' }) => {
  if (!label) {
    return null;
  }

  return (
    <SubLabelStyle data-testid="input-sublabel" htmlFor={inputId}>
      {'('.concat(label).concat(')')}
      {required ? (
        <RequiredSymbol data-testid="input-sublabel-required">
          {REQUIRED_SYMBOL}
        </RequiredSymbol>
      ) : null}
    </SubLabelStyle>
  );
};

export default memo(InputSubLabel);
